import { HttpHeaders } from "@angular/common/http";
import { storageHelper } from "./storage.misc";
import { jwtTokenIdentifier } from "./utilities.misc";

export const getAuthToken = () => {
  let authToken = storageHelper.local.get(`${jwtTokenIdentifier}`) ?? "";
  return authToken;
}

export const headers = {
  formData: { headers: { "bodyType": "form-data" } },

  json: { headers: { "Content-Type": "application/json", "Accept": "application/json" } },

  file: () => {
    let headers = new HttpHeaders({
      "Authorization": `Bearer ${getAuthToken()}`
    });
    return { headers: headers };
  },

  bare: () => {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json"
    });
    return { headers: headers };
  },


  authenticated: () => {
    const token = getAuthToken();

    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json"
    });

    if (token) {
      headers = headers.set("Authorization", `Bearer ${token}`);
    }

    return { headers: headers };
  }

}

